module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BookItalic-WebXL-284459516f0d5ff10e35194f713109fc.woff2";